import React from "react";

export default function Map() {
  return (
    <div className="office-google-map-wrapper">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3797.9943779441774!2d83.19740170807827!3d17.83889848305691!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a3967004d5e3093%3A0xc4548bcc83bec0ec!2sARENA%20WATER%20PARK!5e0!3m2!1sen!2sin!4v1775284160074!5m2!1sen!2sin"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      />
    </div>
  );
}
